import React from 'react'
import { Form } from 'semantic-ui-react'

export default class PayLaterField extends React.PureComponent {
  render() {
    const { value, onChange } = this.props

    const options = [{ key: 1, text: 'No', value: false }, { key: 2, text: 'Yes', value: true }]

    return (
      <Form.Select
        required
        fluid
        label="Pay Later"
        options={options}
        placeholder="Is this Store collecting payment at the end of the month?"
        onChange={(e, data) => onChange('merchant_settlement', data.value)}
        value={value}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/payLaterField.js